
// document_types
export const GET_DOCUMENT_TYPES = "/document_types";
export const ADD_NEW_DOCUMENT_TYPE = "/document_types";
export const UPDATE_DOCUMENT_TYPE = "/document_types";
export const DELETE_DOCUMENT_TYPE = "/document_types";


